import { useMemo } from 'react'
import { Card, Spinner, Alert } from 'react-bootstrap'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from './highcharts-init'
import { useAdminAnalyticsTimeSeries } from 'api/hooks/use-admin-analytics'
import EmptyState from 'shared/empty-state'

const TimeSeriesChart = ({ title, subtitle, endpoint, params, yAxisTitle, color = '#0d6efd' }) => {
  const { data, isLoading, isError } = useAdminAnalyticsTimeSeries({
    endpoint,
    params
  })

  const chartOptions = useMemo(() => ({
    chart: { type: 'area', zoomType: 'x' },
    title: { text: '' },
    credits: { enabled: false },
    exporting: {
      enabled: true,
      filename: title,
      fallbackToExportServer: false,
      libURL: '',
      buttons: { contextButton: { enabled: false } }
    },
    xAxis: {
      type: 'category',
      categories: data?.map((d) => d.date) || [],
      labels: {
        rotation: -45,
        style: { fontSize: '11px' }
      }
    },
    yAxis: {
      title: { text: yAxisTitle || 'Count' },
      min: 0,
      allowDecimals: false
    },
    tooltip: {
      headerFormat: '<b>{point.x}</b><br/>',
      pointFormat: `${yAxisTitle}: {point.y:,.0f}`
    },
    plotOptions: {
      area: {
        fillOpacity: 0.15,
        marker: { enabled: false, radius: 2 },
        lineWidth: 2
      }
    },
    series: [{
      name: yAxisTitle,
      data: data?.map((d) => d.count) || [],
      color: color,
      showInLegend: false
    }]
  }), [data, title, yAxisTitle, color])

  return (
    <Card className="h-100">
      <Card.Header className="bg-white">
        <div className="fw-bold">{title}</div>
        {subtitle && <div className="text-muted" style={{ fontSize: '0.8rem' }}>{subtitle}</div>}
      </Card.Header>
      <Card.Body>
        {isLoading && <div className="text-center py-5"><Spinner /></div>}
        {isError && <Alert variant="danger">Failed to load data</Alert>}
        {!isLoading && !isError && data?.length > 0 && (
          <HighchartsReact highcharts={Highcharts} options={chartOptions} immutable />
        )}
        {!isLoading && !isError && data?.length === 0 && (
          <EmptyState />
        )}
      </Card.Body>
    </Card>
  )
}

export default TimeSeriesChart
